// extracted by mini-css-extract-plugin
module.exports = {"authFrame":"_3UsaaLLEhKAH9q2VhjlICN","loginFrame":"_2K205ne5v3Wua0Z4Sljb6S _3UsaaLLEhKAH9q2VhjlICN","webmasterRegisterFrame":"_3CeN83sK8h0Dyoy9Qzapqt _3UsaaLLEhKAH9q2VhjlICN"};